import Constants from '@/Constants';
import { momentWithTimeZone } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { LocaleData } from '@/translations/LocaleData';
import React from 'react';
import { useSelector } from 'react-redux';
import { DateFieldNames } from '..';
import './style.scss';

interface Props {
    fieldName: DateFieldNames;
    dateForm?: Date;
    enabled: boolean;
    chooseDateText: string;
    buttonText: string;
    onClick: () => void;
    onClear: () => void;
}

const PeriodButton: React.FC<Props> = ({ chooseDateText, buttonText, fieldName, dateForm, enabled, onClick, onClear }) => {
    const strings: LocaleData = useSelector((state: ApplicationState) => state.locale.data);

    const isFinishDate: boolean = fieldName === DateFieldNames.finishDate;

    const handleOnClear = (event: React.MouseEvent): void => {
        event.stopPropagation();

        onClear();
    };

    return (
        <div className="period-button-container mr-3">
            <button className={`period-button-container__button-primary ${dateForm ? 'selected' : ''}`} disabled={!enabled} onClick={onClick}>
                <i className="material-icons-outlined align-middle">{Constants.icons.CALENDAR_TODAY}</i>

                {dateForm ? (
                    <>
                        <span className="m-left--xs">{`${buttonText}: ${momentWithTimeZone(dateForm, strings._LANGUAGE)}`}</span>

                        <i className="material-icons-outlined clear-date" onClick={handleOnClear}>
                            {Constants.icons.CLOSE}
                        </i>
                    </>
                ) : (
                    <span className="m-left--xs">{chooseDateText}</span>
                )}
            </button>

            {isFinishDate && <span className="period-button-container__input-section__info">{strings.END_DATE_INFO}</span>}
        </div>
    );
};

export { PeriodButton };
